var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usage-guide hidden-sm-and-down",on:{"click":_vm.linkTo}},[_c('i',{staticClass:"icon icon-question"}),_c('span',[_vm._v(_vm._s(_vm.$t('usage')))])])}
var staticRenderFns = []

export { render, staticRenderFns }